import http from 'axios'

const state = {
  infobits: [],           // set to empty (instead undefined) for initial sort
  loading: false,         // true while inbox is loading (spinner is displayed)
  filter: {
    username: '',         // user filter: a username/creator (string) or empty for no filtering
    type: '',             // type filter: infobit type URI (string) or empty for no filtering
    searchterm: '',       // title filter: searchterm (string)  or empty for no filtering
    startDate: undefined, // date filter: date object or undefined for no start time filtering
    endDate: undefined    // date filter: date object or undefined for no end time filtering
  }
}

const getters = {
  filteredInboxInfobits: state => {
    if (state.filter.searchterm) {
      return searchInbox(state.infobits).filter(inboxFilter).sort((i1, i2) => i2.created - i1.created)
    } else {
      return state.infobits.filter(inboxFilter).sort((i1, i2) => i2.created - i1.created)
    }
  }
}

const actions = {

  removeInfobitFromInbox ({dispatch}, infobitId) {
    http.delete('/infobits/inbox/infobit/' + infobitId)
    dispatch('deselectInfobitIfSelected', infobitId)
  },

  resetStartDateFilter ({state}) {
    state.filter.startDate = undefined
  },

  resetEndDateFilter ({state}) {
    state.filter.endDate = undefined
  },

  searchInbox ({state, dispatch}) {
    if (state.filter.searchterm) {
      searchInbox(state.infobits)
    }
  },

  // WebSocket messages

  _addInfobitToInbox ({state}, {infobit}) {
    state.infobits.push(infobit)
  },

  _removeInfobitFromInbox ({state}, {infobitId}) {
    findInfobitInInbox(infobitId, (_, i) => state.infobits.splice(i, 1))
  },

  _updateInfobit (_, {infobit}) {
    findInfobitInInbox(infobit.id, i => {
      i.title = infobit.title
    })
  },

  _retypeInfobit (_, {infobitId, type}) {
    findInfobitInInbox(infobitId, i => {
      i.type = type
    })
  }
}

export default {
  state,
  getters,
  actions
}

// Helper

function searchInbox (infobits) {
  var foundInfobits = []
  infobits.forEach(infobit => {
    console.log('hasMatch', hasMatch(infobit))
    if (hasMatch(infobit)) {
      foundInfobits.push(infobit)
    }
  })
  return foundInfobits
}

function hasMatch (infobit) {
  let terms = state.filter.searchterm.split(' ')
  for (var i = 0, term; (i < terms.length); i++) {
    term = terms[i]
    if (infobit.title.toLowerCase().indexOf(term.toLowerCase()) <= -1) {
      return false
    }
  }
  return true
}

/**
 * @return  true if the infobit matches the inbox filter, false otherwise.
 */

function inboxFilter (infobit) {
  var MILLIS_PER_DAY = 24 * 60 * 60 * 1000
  //
  if (infobit.creator.toLowerCase().indexOf(state.filter.username.toLowerCase()) === -1) {
    return false
  }
  if (infobit.type.indexOf(state.filter.type.toLowerCase()) === -1) {
    return false
  }

 /*
  if (infobit.title.toLowerCase().indexOf(state.filter.searchterm.toLowerCase()) === -1) {
    return false
  }
*/
  if (state.filter.startDate && infobit.created < state.filter.startDate.getTime()) {
    return false
  }
  if (state.filter.endDate && infobit.created >= state.filter.endDate.getTime() + MILLIS_PER_DAY) {
    return false
  }
  return true
}

function findInfobitInInbox (id, callback) {
  var i = state.infobits.findIndex(i => i.id === id)
  if (i !== -1) {
    callback(state.infobits[i], i)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/inbox.js